module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/messageforums/bravenet_messageforums_embed_anywhere.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/messageforums/bravenet_messageforums_embed_anywhere.png
// module id = COg+
// module chunks = 0